import AtmLocationsPresentational from '@pages/atm-locations/components/AtmLocationsPresentational';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import Actions from '../action';
import selectors from '../selectors';
import AuthorizedSignatoryPresentational from './authorised-signatory-Presentational';

const AuthorizedSignatoryFunctional = ({ buttonMode, buttonName, navigateDisabled, sendEmailStart, isAuthorisedLoading }) => {
	useEffect(() => {
		buttonMode?.('single');
		buttonName?.('Send Agreement for Signature');
	}, []);
	return (
		<>
			<AuthorizedSignatoryPresentational navigateDisabled={navigateDisabled} isAuthorisedLoading={isAuthorisedLoading} sendEmailStart={sendEmailStart}></AuthorizedSignatoryPresentational>
		</>
	);
};

const mapStateToProps = (state) => {
	return {
		isAuthorisedLoading: selectors.isAuthorisedLoading(state),
	};
};
const mapDispatchToProps = (dispatch) => {
	return {
		sendEmailStart: (email, history) => dispatch(Actions.creators.sendEmailStart(email, history)),
	};
};

const Connected = connect(mapStateToProps, mapDispatchToProps)(AuthorizedSignatoryFunctional);
export default Connected;
